export const getAddonsFromCookie = () => {
  const addonsCookie =
    document.cookie
      .split('; ')
      .find((row) => row.startsWith('nie-addons'))
      ?.split('=')[1] || '';

  return addonsCookie ? JSON.parse(decodeURIComponent(addonsCookie)) : [];
};

export const setAddonCookie = (addons?: string[]) => {
  if (!addons) {
    document.cookie = `nie-addons=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
    return;
  }
  const cookieValue = JSON.stringify(addons);

  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);

  document.cookie = `nie-addons=${encodeURIComponent(
    cookieValue
  )}; path=/; expires=${expirationDate.toUTCString()}`;
};
